var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-11 mx-auto" },
          [
            _c("RenamableProperty", {
              attrs: {
                inputClasses: "rename-input",
                name: _vm.name,
                locked: _vm.lockedByParent
              },
              on: {
                "rename-property": function($event) {
                  return _vm.$emit("rename-page", $event)
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "TemplateItem",
        {
          attrs: {
            metadata: _vm.metadata,
            isSelected: _vm.isSelected,
            classes: _vm.classes,
            parentId: _vm.parentId,
            styles: _vm.pageStyle,
            controlsStyle: "right: -33px; top: -26px;",
            isParent: _vm.isParent,
            locked: _vm.locked
          },
          on: {
            "delete-item": function($event) {
              return _vm.$emit("delete-page", $event)
            },
            "select-item": function($event) {
              return _vm.$emit("select-page")
            },
            "move-item": function($event) {
              return _vm.$emit("move-page", $event)
            },
            "rename-item": function($event) {
              return _vm.$emit("rename-page", $event)
            },
            "lock-item": function($event) {
              return _vm.$emit("lock-page", $event)
            },
            "unselect-all": function($event) {
              _vm.selectedBlock = null
            }
          }
        },
        [
          _vm.showSettings
            ? [
                _c("TemplatePageSettings", {
                  attrs: {
                    width: _vm.metadata.style.width,
                    color: _vm.metadata.style.color,
                    margin: _vm.metadata.style.margin,
                    "media-id": _vm.metadata.style.mediaId
                  },
                  on: {
                    "change-width": function($event) {
                      return _vm.$emit("change-width", $event)
                    },
                    "change-color": function($event) {
                      return _vm.$emit("change-color", $event)
                    },
                    "change-image": function($event) {
                      return _vm.$emit("change-image", $event)
                    },
                    "change-crop": function($event) {
                      return _vm.$emit("change-crop", $event)
                    },
                    "change-margin": function($event) {
                      return _vm.$emit("change-margin", $event)
                    }
                  }
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.sortedBlocks, function(block) {
            return _c("templateBlock", {
              key: block._key,
              attrs: {
                id: block.Id,
                currentTemplateId: _vm.currentTemplateId,
                templateId: block.TemplateId,
                parentId: block.ParentId,
                isSelected: _vm.selectedBlock === block,
                locked: block.IsLocked,
                lockStateChanged: block.LockStateChanged,
                pageId: block.PageId,
                metadata: block.Metadata,
                rows: block.Rows,
                settings: { margin: _vm.metadata.style.margin },
                parentColor: _vm.metadata.style.color
              },
              on: {
                "select-block": function($event) {
                  _vm.selectedBlock = block
                },
                "delete-block": function($event) {
                  return _vm.deleteBlock($event)
                },
                "move-block": function($event) {
                  return _vm.moveBlock($event.old, $event.new)
                },
                "lock-block": function($event) {
                  return _vm.toggleBlockLock(block, $event)
                },
                "change-width": function($event) {
                  block.Metadata.style.width = $event
                },
                "change-color": function($event) {
                  block.Metadata.style.color = $event
                },
                "change-border-color": function($event) {
                  block.Metadata.style.borderColor = $event
                },
                "change-radius": function($event) {
                  block.Metadata.style.radius = $event
                },
                "item-added": function($event) {
                  return _vm.$emit("item-added")
                },
                "set-border": function($event) {
                  block.Metadata.style.border = $event
                }
              }
            })
          }),
          _vm._v(" "),
          !_vm.lockedByParent
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-auto mx-auto" }, [
                  _c("i", {
                    staticClass: "mdb-icon-btn new fa fa-plus-circle fa-2x",
                    attrs: {
                      "data-toggle": "tooltip",
                      title: _vm.tooltips.insertBlock
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.addBlock()
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("pagenumber")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }